"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Navbar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _NavbarModule = _interopRequireDefault(require("./Navbar.module.css"));
var _useDimension2 = require("../../hooks/useDimension");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var navItems = [{
  label: 'სპორტი',
  url: '/sport'
}, {
  label: 'LIVE',
  url: '/live'
}, {
  label: 'ვირტ.სპორტი',
  url: '/v-sport'
  /* children: {
     betradar: ['ფეხბურთი', 'მსოფლიო თასი'],
     kiron: ['პრემიერ ლიგა', 'სერია ა'],
   },*/
}, {
  label: 'პოკერი',
  url: '/poker',
  children: [{
    label: 'სპინ პოკერი',
    url: '#'
  }, {
    label: 'ლიდერ პოკერი',
    url: '#'
  }]
}, {
  label: 'LIVE კაზინო',
  url: '/liveCasino',
  children: [{
    label: 'Playtech Live Casino',
    url: '#'
  }, {
    label: 'Evolution Live Casino',
    url: '#'
  }]
}, {
  label: 'სლოტები',
  url: '/slots'
}, {
  label: 'მაგიდის თამაშები',
  url: '/games',
  children: [{
    label: 'ბურა',
    url: '#'
  }, {
    label: 'სეკა',
    url: '#'
  }, {
    label: 'დომინო',
    url: '#'
  }]
}, {
  label: 'კენო',
  url: '/keno'
}, {
  label: 'ჯოკერი',
  url: '#',
  children: [{
    label: 'ჯოკერი',
    url: '#'
  }, {
    label: 'სპინ ჯოკერი',
    url: '#'
  }, {
    label: 'უფასო ჯოკერი',
    url: '#'
  }, {
    label: 'იაპონური ჯოკერი',
    url: '#'
  }]
}, {
  label: 'სპინ თამაშები',
  url: '/games'
}, {
  label: 'ვოლტი',
  url: '/playVolt'
}];
var Navbar = function Navbar() {
  var _useDimension = (0, _useDimension2.useDimension)(),
    clientWidth = _useDimension.clientWidth;
  /*const count = useMemo(() => {
    switch (clientWidth) {
      case 'chitovic':
      case 'md':
        return 4;
      case 'lg':
        return 6;
      case 'xl':
        return 9;
      case 'xxl':
      default:
        return 11;
    }
  }, [size]);*/
  var count = (0, _react.useMemo)(function () {
    if (clientWidth < 550) return 3;
    if (clientWidth < 650) return 4;
    if (clientWidth < 720) return 5;
    if (clientWidth < 830) return 6;
    if (clientWidth < 890) return 7;
    if (clientWidth < 950) return 8;
    if (clientWidth < 1050) return 9;
    return 11;
  }, [clientWidth]);
  return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Container, {
    fluid: 'gigantic'
  }, /*#__PURE__*/_react.default.createElement("nav", {
    className: _NavbarModule.default.nav
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    className: _NavbarModule.default.home
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _NavbarModule.default.list
  }, navItems.map(function (item, index) {
    return index < count && /*#__PURE__*/_react.default.createElement("div", {
      className: _NavbarModule.default.listItem,
      key: index
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: item.url,
      className: _NavbarModule.default.link
    }, item.label), item.children && /*#__PURE__*/_react.default.createElement("div", {
      className: _NavbarModule.default.dropdown
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: _NavbarModule.default.list
    }, item.children.map(function (i, index) {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: index
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: i.url
      }, i.label));
    }))));
  }), count < 11 && /*#__PURE__*/_react.default.createElement("div", {
    className: _NavbarModule.default.listItem
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _NavbarModule.default.link
  }, "\u10DB\u10D4\u10E2\u10D8"), /*#__PURE__*/_react.default.createElement("div", {
    className: _NavbarModule.default.dropdown
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: _NavbarModule.default.list
  }, _lodash.default.slice(navItems, count).map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: item.url
    }, item.label));
  })))))));
};
exports.Navbar = Navbar;